<template>
  <div
    v-if="canShow"
    class="mb-1 flex flex-col gap-3 p-2 bg-white dark:bg-dmGray1 border border-neutral6 dark:border-dmGray1 rounded">
    <div class="flex flex-col 2xl:flex-row gap-2 pt-1">
      <span class="text-xs">{{ t('site_pro.additional_services.extra_photos.title') }}</span>

      <div class="flex gap-2">
        <Tooltip :text="toolTipText.show_modal" trigger="hover">
          <i
            class="fa-solid fa-circle-info text-neutral3 dark:text-dmText3 cursor-pointer"
            @click="handleOpenServicesResultsModal(shipment)" />
        </Tooltip>

        <Tooltip :text="toolTipText.extra_photos">
          <i class="fa-solid fa-question-circle text-neutral3 dark:text-dmText3 cursor-pointer" />
        </Tooltip>
      </div>
    </div>
    <div>
      {{
        toPrice(
          getRequestAdvancedPhotosPrice(
            shipment,
            contentStore.additionalServicesConfig?.request_additional_photos.price
          )
        )
      }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useSiteProContentStore } from '~/store/shipzeeProContentStore'
import type { PackageInterface } from '~/types/shipzeePro/packagesTypes'

import { useLang } from '~/composables/useLang'
import getRequestAdvancedPhotosPrice from '../../../utils/shipzeePro/getRequestAdvancedPhotosPrice'
import getRequestAdvancedPhotosDate from '~/utils/shipzeePro/getRequestAdvancedPhotosDate'
import toPrice from '../../../utils/toPrice'
import Tooltip from '~/components/Tooltip.vue'

const props = defineProps<{
  shipment: PackageInterface
}>()

const { t } = useLang()
const contentStore = useSiteProContentStore()

const emit = defineEmits(['handleOpenServicesResultsModal'])

function handleOpenServicesResultsModal(shipment: PackageInterface): void {
  emit('handleOpenServicesResultsModal', shipment)
}

const canShow = computed(() => {
  return (
    getRequestAdvancedPhotosPrice(
      props.shipment,
      contentStore.additionalServicesConfig?.request_additional_photos.price
    ) !== null
  )
})

const toolTipText = computed(() => {
  return {
    show_modal: t('site_pro.additional_services.extra_photos.tooltip_show_modal_description'),
    extra_photos: t('site_pro.additional_services.extra_photos.tooltip_description', {
      date: getRequestAdvancedPhotosDate(props.shipment),
    }),
  }
})
</script>
